import { Organisme } from '../../models/organisme';

export interface OrganismeBillingHttp {
  id: string;
  code: string;
  company_name: string;
  payment_method: string;
  siret: string;
  line1: string;
  line2: string;
  line3: string;
  postal_code: string;
  city: string;
  tva_intracom?: string;
  country_code?: string;
  type?: string;
}

export const fromOrganismeBillingHttpToOrganisme = (
  organismeBillingHttp: OrganismeBillingHttp,
): Organisme => ({
  id: organismeBillingHttp.id,
  crpcen: organismeBillingHttp.code,
  nom: organismeBillingHttp.company_name,
  billing: {
    siret: organismeBillingHttp.siret,
    paymentMethod: organismeBillingHttp.payment_method,
    addressLine1: organismeBillingHttp.line1,
    addressLine2: organismeBillingHttp.line2,
    addressLine3: organismeBillingHttp.line3,
    postalCode: organismeBillingHttp.postal_code,
    city: organismeBillingHttp.city,
    tvaIntracommunautaire: organismeBillingHttp.tva_intracom,
    countryCode: organismeBillingHttp.country_code,
    type: organismeBillingHttp.type,
  },
});
